import type { Action } from 'redux'
import type { ApiResponse } from '../../../../../config/api-types'
import { LOGOUT } from '../../../../authentication/presentation/redux/types/log-out-types'
import * as types from '../types/get-collection-order-status-types'

export const InitialGetCollectionOrderStatus = {
  data: null as unknown as ApiResponse,
  load: false,
  error: '',
  success: false,
}

export const getCollectionOrderStatusReducer = (
  state = InitialGetCollectionOrderStatus,
  action: Action & { payload?: any },
) => {
  const newState = { ...state }
  switch (action.type) {
    case types.GET_COLLECTION_ORDER_STATUS_REQUEST:
      newState.load = true
      return newState

    case types.GET_COLLECTION_ORDER_STATUS_ERROR:
      newState.load = false
      newState.error = action.payload
      newState.success = false
      return newState

    case types.GET_COLLECTION_ORDER_STATUS_SUCCESS:
      newState.load = false
      newState.error = ''
      newState.data = action.payload
      newState.success = true
      return newState

    case types.GET_COLLECTION_ORDER_STATUS_RESET:
      return InitialGetCollectionOrderStatus

    case LOGOUT:
      return InitialGetCollectionOrderStatus

    default:
      return { ...state }
  }
}
